import { Component, Input, OnInit, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { UrlType } from '../../enum/url-type';
import { LinkTargetType } from '../../interface/link';
import { AppConfigService } from '../../../service/app-config.service';
import { getButtonStyle } from '../../utils/get-button-style';

export interface IButtonData {
  type?: UrlType;
  name?: string;
  queryString?: string;
  target?: LinkTargetType;
  url?: string;
}

@Component({
  selector: 'app-bg-button',
  templateUrl: './bg-button.component.html',
  styleUrls: ['./bg-button.component.less']
})
export class BGButtonComponent implements OnInit {
  @Input() data: IButtonData;
  @Input() buttonColor: string;
  @Input() styleAsText?: boolean;
  @ViewChildren('linkEl') linkEls!: QueryList<ElementRef<HTMLElement>>;

  buttonClass: string;
  urlType = UrlType;

  textSize = "32px"; // Possibly make these arguments from umbraco
  textWeight = "400"; // Possibly make these arguments from umbraco
  textColor: string; // Used to define the text color if styleAsText is enabled
  secondaryColor: string; // used to define color of arrow border if styleAsText is enabled

  ngOnInit() {
    if (!this.data) return;

    if (this.data.target) this.data.type = UrlType.External;

    if (this.data.type === UrlType.Media) {
      if (!this.data.target) this.data.target = '_blank';
    }

    const buttonStyle = getButtonStyle(this.buttonColor);

    this.buttonClass = buttonStyle && buttonStyle.buttonClass;
    if (buttonStyle && buttonStyle.colorStyle) {
      this.setColorStyle(buttonStyle.colorStyle);
    }
  }

  ngAfterViewInit() {
    this.setCustomThemeProperties();
  }

  private setCustomThemeProperties() {
    if (this.styleAsText) {
      const linkEl = this.linkEls.first;
      linkEl.nativeElement.style.setProperty('--link-text-color', this.textColor);

      if (this.secondaryColor) linkEl.nativeElement.style.setProperty('--link-secondary-color', this.secondaryColor);

      linkEl.nativeElement.style.setProperty('--link-text-size', this.textSize);
      linkEl.nativeElement.style.setProperty('--link-text-weight', this.textWeight);
    }
  }

  private setColorStyle(colors: string[]) {
    if (!this.styleAsText) return;

    this.textColor = colors[0];

    if (colors.length === 2) {
      this.secondaryColor = colors[1];
    }
  }
}
